"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../utils");

var _withTheme = require("../../wrappers/with-theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _default = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var large = _ref.large,
      small = _ref.small,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      children = _ref.children,
      _onChange = _ref.onChange,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ["large", "small", "className", "children", "onChange", "value"]);

  var theme = (0, _withTheme.useTheme)(),
      inputTheme = theme["input".concat((0, _utils.composeOptions)({
    large: large,
    small: small
  }))];
  return /*#__PURE__*/_react["default"].createElement("textarea", _extends({}, props, {
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    value: value || "",
    className: "".concat(inputTheme, " ").concat(className),
    ref: ref,
    rows: 6
  }), children);
});

exports["default"] = _default;